import React from "react";

type Props = {
    className?  : string
    title?      : string
}

export default function PopoverMenuHeader(props:Props) {
    return (
        <div className={Classes("ui5-title-smaller-dark txt-semibold m-l-20 m-r-20 m-t-15 m-b-12", props.className)}>     {/* artur: ui5-title-small > smaller-dark; m-b-15 > m-b-12*/}
            <div className="left">
                <div className="name">{props.title}</div>
            </div>
        </div>
    )
}